// material-ui
import LinearProgress from '@mui/material/LinearProgress';

// ==============================|| LOADER ||============================== //
const Loader = () => (<LinearProgress sx={{position: 'fixed', top: 0, left: 0, zIndex: 1301, width: '100%'}} color='success' />);

export default Loader;